// extracted by mini-css-extract-plugin
module.exports = {"clothesCard":"Clothes_clothesCard__2Uhy6","banner":"Clothes_banner__15dUi"};